<template>
	<div>
		<card style="margin-bottom: 20px;">
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input v-model="name" placeholder="搜索团队客户"  />
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">状态</span>
					<Select v-model="status" placeholder="状态" >	
						<Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">星级</span>
					<Select v-model="start" placeholder="星级" >
						<Option v-for="item in starsFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">未跟进天数</span>
					<Input v-model="notFollowTimeValue" placeholder="单位/天" style="width: 150px"
						 />
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">申请时间</span>
					<DatePicker type="daterange" :value="apply_time" placeholder="申请时间" @on-change="applyTimeChange">
					</DatePicker>
					</Cascader>
				</div>	
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">来源</span>
					<Select v-model="media" style="width:200px" placeholder="媒体代码" >
						<Option v-for="item in categoryList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">再分配时间超过</span>
					<Input v-model="notFollowJoinTimeValue" placeholder="单位/天" style="width: 150px"
						 />
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon">备注</span>
						<Input v-model="remark" placeholder="备注" style="width: 150px"/>
					</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.menu == 'team_lock_customer_list'">
					<div class="input-group">
					<span class="input-group-addon">跟进团队</span>
					<Select  v-model="followDepartment"
						style="width:150px;" placeholder="跟进团队" >
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
					</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.menu == 'team_lock_customer_list'">
					<div class="input-group">
					<span class="input-group-addon">跟进人</span>
					<Select  v-model="followUid"
						style="width:150px;" placeholder="跟进人" >
						<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
					</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon chaxun">跟进状态</span>
						<div class="input-group-addon my_client">
							<input type="checkbox" v-model="is_follow" checked="checked"><span>未跟进</span>
						</div>
					</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<Button @click="mySearch" type="primary" style="margin-left: 20px;">查询</Button>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col style="float: left;">
					<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
					<Button @click="addClue" type="primary" style="margin-left: 20px;">添加客户</Button>
					<Button @click="addPoolBatch" type="primary" style="margin-left: 20px;">放入公共池</Button>
					<Button v-if="this.menu == 'team_lock_customer_list'" @click="allUnlock" type="primary" style="margin-left: 20px;">一键解锁</Button>
				</Col>
			</Row>
		</card>
		<div class="multiple" style="width: 100%">
			<Table :columns="columns" :data="datas" size="small" ref="table" :row-class-name="rowClassName">
				<template slot-scope="{ row }" slot="name">
					<span v-if="menuName != 'client_search'" style="color:#63B3E6;cursor: pointer;" @click.stop="edit"
						:data-id="row.id" :data-name="row.name">{{row.name}}</span>
					<span v-if="menuName == 'client_search'">{{row.name}}</span>
				</template>
				<template slot-scope="{ row }" slot="make_state">
					<img v-for="(item, index) in row.make_state" style="width: 20px; margin-top: 5px" :src="item" />
					<div v-if="row.make_state.length == 0">无</div>
				</template>
				<template slot-scope="{ row }" slot="loans_money">
					<span>{{row.loans_money/10000}}万</span>
				</template>
				<template slot-scope="{ row }" slot="entrust">
					<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">
						{{item.content}} {{item.created_at}}
					</div>
					<div v-if="row.entrust.length == 0">无</div>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<!-- 编辑客户 -->
		<div v-if="editDiv" style="background: #f9fafc;">
			<Modal v-model="editModal" width="95%" title="" footer-hide :styles="editModalStyle">
				<NewEditClue @reloadData="getList" @beforeOne="beforeEditOne" @nextOne="nextEditOne" :id="clientId"
					ref="NewEditClue">
				</NewEditClue>
			</Modal>
		</div>
		<!-- 新增客户 -->
		<Modal v-model="addClientModal" width="45%" title="">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">姓名</label>
				<Input v-model="client.name" placeholder="请输入姓名" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">性别</label>
				<Select v-model="client.sex">
					<Option :value="1">男</Option>
					<Option :value="2">女</Option>
				</Select>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">电话号码</label>
				<Input v-model="client.phone" placeholder="请输入电话号码" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">城市</label>
				<Input v-model="client.city" placeholder="请输入城市" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">年龄</label>
				<Input v-model="client.age" placeholder="请输入年龄" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">贷款金额</label>
				<Input v-model="client.money" placeholder="请输入贷款金额" />
			</div>
			<div slot="footer">
				<Button type="text" @click="addClientModal=false">取消</Button>
				<Button type="primary" @click="addClient">确定</Button>
			</div>
		</Modal>
		<!-- 选择分配人 -->
		<Modal v-model="giveOutModal" width="650" title="选择分配人">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">分配给</div>
				<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
					<span>全选</span>
				</Checkbox>
				<CheckboxGroup v-model="giveOutUid" @on-change="checkAllGroupChange">
					<Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="giveOutBatch">确定</Button>
			</div>
		</Modal>
		<!-- 添加跟进记录 -->
		<Modal v-model="modal" width="1200" footer-hide>
			<quickEditClue @quickEditClient="quickEditClient" @reloadData="getList" @beforeOne="beforeOne"
				ref="quickEditClue" @nextOne="nextOne" :id="addRecordId"></quickEditClue>
		</Modal>
		<!-- 客户提醒 -->
		<Modal v-model="clientTipsModal" :title="clientTips.title" cancel-text="">
			<p v-if="clientTips.type == 1">您与<span class='client_name' @click='edit'
					:data-id='clientTips.id'>{{clientTips.name}}</span>客户约定{{clientTips.plat_at}}回电/上门已到期，请及时处理</p>
			<p v-if="clientTips.type == 2">您有一条新客户<span class='client_name' @click='edit'
					:data-id='clientTips.id'>{{clientTips.name}}</span>进入系统，请及时处理</p>
		</Modal>
	</div>
</template>
<script>
	import quickEditClue from './quickEditClue.vue'
	import EditClue from './EditClue.vue'
	import NewEditClue from './NewEditClue.vue'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getList,
		addSea,
		addPool,
		allUnlock,
		lock,
		giveOut,
		getCount,
		transferUser,
		saveClient,
	} from '@/api/client'
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getTeamList,
		getDepartmentList,
	} from '@/api/user'
	import {
		getAllMediumCode
	} from "../../api/runSet";

	export default {
		name: "ImportantClient",
		components: {
			quickEditClue,
			EditClue,
			NewEditClue
		},
		props: {
			needInitSearch: {
				type: Boolean
			},
			menuName: {
				type: String
			},
			openMenuName: {
				type: String
			},
		},
		data() {
			return {
				clientTips: {
					title: '',
					clientId: 0,
					type: 0,
					name: '',
					plat_at: '',
				},
				clientTipsModal: false,
				notFollowTime: false,
				screeningSwitch: false,
				apply_time: [],
				join_time: [],
				followTimes: 0,
				followUid: [],
				followDepartment: [],
				loanMoney: 0,
				start: [],
				status: [],
				is_follow: false,
				is_house: '',
				is_car: '',
				is_accumulation: '',
				is_social_security: '',
				is_weilidai: '',
				is_salary: '',
				is_credit_card: '',
				is_pay_taxes: '',
				orderBy: '',
				indeterminate: true,
				checkAll: false,
				addClientModal: false,
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				client: {
					'name': '',
					'phone': '',
					'sex': '',
					'city': '',
					'age': '',
					'loans_money': '',

				},
				editDiv: false,
				editModal: false,
				clientId: 0,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200, 500],
				announce: '',
				announceImg: require('../../assets/images/announce.png'),
				countDataImg: {
					exclamatory: require('../../assets/images/exclamatory.png'),
					refresh: require('../../assets/images/refresh.png'),
				},
				countData: {
					soon_collect: '**',
					un_lock: '**',
					untreated: '**',
					not_follow_5: '**',
					not_follow_3: '**',
					not_follow_1: '**',
					not_follow_1_start: '**',
				},
				giveOutId: 0,
				giveOutUid: [],
				giveOutModal: false,
				transferModal: false,
				addRecordId: 0,
				foldShow: false,
				modal: false, //添加跟进记录
				media: [], //媒体代码
				apply: [], //申请条件
				count: 0,
				page: 1,
				name: '',
				remark: '',
				timeDimension: [],
				timePeriod: 0,
				notFollowTimeValue: '',
				notFollowJoinTimeValue:'',
				call_tag: [],
				isComment: 0,
				userList: [],
				is_offer: [],
				makeState: [],
				clientType: [],
				timePeriodDate: [],
				categoryList: [],
				oldDatas: [],
				teamList: [],
				departmentList: [],
				datas: [],
				statusFilters: [{
					label: '未处理',
					value: '1'
				}, {
					label: '待跟进',
					value: '2'
				}, {
					label: '邀约中',
					value: '3'
				}, {
					label: '上门未签约',
					value: '6'
				}, {
					label: '已签约',
					value: '7'
				}, {
					label: '进件中',
					value: '8'
				}, {
					label: '银行拒绝',
					value: '9'
				}, {
					label: '已回款',
					value: '13'
				}, {
					label: '资质不符',
					value: '14'
				}, {
					label: '捣乱申请',
					value: '15'
				}, {
					label: '外地申请',
					value: '16'
				}, {
					label: '重复申请',
					value: '17'
				}],
				starsFilters: [{
						value: 0,
						label: '0星'
					},
					{
						value: 1,
						label: '1星'
					},
					{
						value: 2,
						label: '2星'
					},
					{
						value: 3,
						label: '2星+'
					},
					{
						value: 4,
						label: '3星'
					},
					{
						value: 5,
						label: '4星'
					},
				],
				followTimesfilters: [{
					value: 1,
					label: '0次'
				}, {
					value: 2,
					label: '1-3次'
				}, {
					value: 3,
					label: '4-10次'
				}, {
					value: 4,
					label: '11-20次'
				}, {
					value: 5,
					label: '20次以上'
				}, ],
				conditionLise: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: '有'
					}
				],
				sortLise: [{
						value: 1,
						label: '申请时间降序'
					},
					{
						value: 2,
						label: '申请时间升序'
					},
					{
						value: 3,
						label: '备注时间降序'
					},
					{
						value: 4,
						label: '备注时间升序'
					},
					{
						value: 5,
						label: '分配时间降序'
					},
					{
						value: 6,
						label: '分配时间升序'
					}
				],
				columns: [{
						type: 'selection',
						width: 40,
						align: 'center'
					},

					{
						"title": "客户",
						"slot": "name",
						"width": 80
					},
					{
						"title": "手机",
						"key": "phone",
						"width": 80
					},
					{
						"title": "性别",
						"key": "sex_name",
						"width": 30,
					},
					{
						"title": "星级",
						"key": "start_name",
						"width": 60,
						filters: [{
								value: 0,
								label: '0星'
							},
							{
								value: 1,
								label: '1星'
							},
							{
								value: 2,
								label: '2星'
							},
							{
								value: 3,
								label: '2星+'
							},
							{
								value: 4,
								label: '3星'
							},
							{
								value: 5,
								label: '4星'
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStart(value);
						}
					},
					{
						"title": "状态",
						"key": "status_name",
						filters: [{
							label: '未处理',
							value: '1'
						}, {
							label: '待跟进',
							value: '2'
						}, {
							label: '邀约中',
							value: '3'
						}, {
							label: '上门未签约',
							value: '6'
						}, {
							label: '已签约',
							value: '7'
						}, {
							label: '进件中',
							value: '8'
						}, {
							label: '银行拒绝',
							value: '9'
						}, {
							label: '已回款',
							value: '13'
						}, {
							label: '资质不符',
							value: '14'
						}, {
							label: '捣乱申请',
							value: '15'
						}, {
							label: '外地申请',
							value: '16'
						}, {
							label: '重复申请',
							value: '17'
						}],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStatus(value);
						},
						"width": 60
					},
					{
						"title": "需求额度",
						"slot": "loans_money",
						"width": 70,
						filters: [{
							value: 1,
							label: '1000以下'
						}, {
							value: 2,
							label: '1千-1万'
						}, {
							value: 3,
							label: '1万-2万'
						}, {
							value: 4,
							label: '2万-3万'
						}, {
							value: 5,
							label: '3万以上'
						}, ],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByMoney(value);
						}
					},
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 220
					},
					{
						"title": "申请时间",
						"key": "applied_at",
						"width": 100,
						"sortable": true
					},
					{
						"title": "团队跟进次数",
						"key": "follow_times",
						"width": 55,
						filters: [{
							value: 1,
							label: '0次'
						}, {
							value: 2,
							label: '1-3次'
						}, {
							value: 3,
							label: '4-10次'
						}, {
							value: 4,
							label: '11-20次'
						}, {
							value: 5,
							label: '20次以上'
						}, ],
						filterMultiple: false,
						filterMethod(value, row) {
							if (value == 1) {
								return row.follow_times == 0;
							} else if (value == 2) {
								return row.follow_times > 0 && row.follow_times <= 3;
							} else if (value == 3) {
								return row.follow_times > 3 && row.follow_times <= 10;
							} else if (value == 4) {
								return row.follow_times > 10 && row.follow_times <= 20;
							} else if (value == 5) {
								return row.follow_times > 20;
							}
						}
					},
					{
						"title": "个人跟进次数",
						"key": "personal_follow_times",
						"width": 55,
						filters: [{
							value: 1,
							label: '0次'
						}, {
							value: 2,
							label: '1-3次'
						}, {
							value: 3,
							label: '4-10次'
						}, {
							value: 4,
							label: '11-20次'
						}, {
							value: 5,
							label: '20次以上'
						}, ],
						filterMultiple: false,
						filterMethod(value, row) {
							if (value == 1) {
								return row.personal_follow_times == 0;
							} else if (value == 2) {
								return row.personal_follow_times > 0 && row.personal_follow_times <= 3;
							} else if (value == 3) {
								return row.personal_follow_times > 3 && row.personal_follow_times <= 10;
							} else if (value == 4) {
								return row.personal_follow_times > 10 && row.personal_follow_times <= 20;
							} else if (value == 5) {
								return row.personal_follow_times > 20;
							}
						}
					},
					{
						"title": "最后跟进时间",
						"key": "updated_at",
						"width": 100,
						"sortable": true
					},
					{
						"title": "媒体代码",
						"key": "media_name",
						"width": 80,
					}
				],
				columnsCopy: [{
						type: 'selection',
						width: 40,
						align: 'center'
					},
				
					{
						"title": "客户",
						"slot": "name",
						"width": 80
					},
					{
						"title": "手机",
						"key": "phone",
						"width": 80
					},
					{
						"title": "性别",
						"key": "sex_name",
						"width": 30,
					},
					{
						"title": "星级",
						"key": "start_name",
						"width": 60,
						filters: [{
								value: 0,
								label: '0星'
							},
							{
								value: 1,
								label: '1星'
							},
							{
								value: 2,
								label: '2星'
							},
							{
								value: 3,
								label: '2星+'
							},
							{
								value: 4,
								label: '3星'
							},
							{
								value: 5,
								label: '4星'
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStart(value);
						}
					},
					{
						"title": "状态",
						"key": "status_name",
						filters: [{
							label: '未处理',
							value: '1'
						}, {
							label: '待跟进',
							value: '2'
						}, {
							label: '邀约中',
							value: '3'
						}, {
							label: '上门未签约',
							value: '6'
						}, {
							label: '已签约',
							value: '7'
						}, {
							label: '进件中',
							value: '8'
						}, {
							label: '银行拒绝',
							value: '9'
						}, {
							label: '已回款',
							value: '13'
						}, {
							label: '资质不符',
							value: '14'
						}, {
							label: '捣乱申请',
							value: '15'
						}, {
							label: '外地申请',
							value: '16'
						}, {
							label: '重复申请',
							value: '17'
						}],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStatus(value);
						},
						"width": 60
					},
					{
						"title": "需求额度",
						"slot": "loans_money",
						"width": 70,
						filters: [{
							value: 1,
							label: '1000以下'
						}, {
							value: 2,
							label: '1千-1万'
						}, {
							value: 3,
							label: '1万-2万'
						}, {
							value: 4,
							label: '2万-3万'
						}, {
							value: 5,
							label: '3万以上'
						}, ],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByMoney(value);
						}
					},
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 220
					},
					{
						"title": "申请时间",
						"key": "applied_at",
						"width": 100,
						"sortable": true
					},
					{
						"title": "团队跟进次数",
						"key": "follow_times",
						"width": 55,
						filters: [{
							value: 1,
							label: '0次'
						}, {
							value: 2,
							label: '1-3次'
						}, {
							value: 3,
							label: '4-10次'
						}, {
							value: 4,
							label: '11-20次'
						}, {
							value: 5,
							label: '20次以上'
						}, ],
						filterMultiple: false,
						filterMethod(value, row) {
							if (value == 1) {
								return row.follow_times == 0;
							} else if (value == 2) {
								return row.follow_times > 0 && row.follow_times <= 3;
							} else if (value == 3) {
								return row.follow_times > 3 && row.follow_times <= 10;
							} else if (value == 4) {
								return row.follow_times > 10 && row.follow_times <= 20;
							} else if (value == 5) {
								return row.follow_times > 20;
							}
						}
					},
					{
						"title": "个人跟进次数",
						"key": "personal_follow_times",
						"width": 55,
						filters: [{
							value: 1,
							label: '0次'
						}, {
							value: 2,
							label: '1-3次'
						}, {
							value: 3,
							label: '4-10次'
						}, {
							value: 4,
							label: '11-20次'
						}, {
							value: 5,
							label: '20次以上'
						}, ],
						filterMultiple: false,
						filterMethod(value, row) {
							if (value == 1) {
								return row.personal_follow_times == 0;
							} else if (value == 2) {
								return row.personal_follow_times > 0 && row.personal_follow_times <= 3;
							} else if (value == 3) {
								return row.personal_follow_times > 3 && row.personal_follow_times <= 10;
							} else if (value == 4) {
								return row.personal_follow_times > 10 && row.personal_follow_times <= 20;
							} else if (value == 5) {
								return row.personal_follow_times > 20;
							}
						}
					},
					{
						"title": "最后跟进时间",
						"key": "updated_at",
						"width": 100,
						"sortable": true
					},
					{
						"title": "媒体代码",
						"key": "media_name",
						"width": 80,
					}
				],
				menu:'lock_customer_list',
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo']),
		},
		mounted: function() {
			if(this.$route.params.type){
				if(this.$route.params.type == 2){
					this.menu = 'team_lock_customer_list';
				}else{
					this.menu = 'lock_customer_list';
				}
				
			}
			this.userDisplayTable();
			this.loadData();
			this.getCount();
			this.getList();
		},
		created: function() { //这里是定时器

		},
		watch: {
			$route() { // 监听路由变化  // 组件第一次进入不会执行
				if (this.$route.name == "ImportantClient") {
					if(this.$route.params.type == 2){
						this.menu = 'team_lock_customer_list';
					}else{
						this.menu = 'lock_customer_list';
					}
				}
			},
			menu() {
				this.getList();
			},
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			async getAnnounce() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getAnnounce(that, data);
				if (res.code == 1) {
					that.announce = res.data.text;
				}
			},
			async myTips() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getMyClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			rowClassName(row, index) {
				if (row.is_updated > 0) {
					return 'table-blue-row';
				} else {
					return 'table-black-row';
				}
			},
			changeSwitch(status) {
				this.screeningSwitch = status;
			},
			mySearchByFollow(followUid) {
				this.followUid = followUid;
				this.page = 1;
				this.getList();
			},
			mySearchByDepartment(followDepartment) {
				this.followDepartment = followDepartment;
				this.page = 1;
				this.getList();
			},
			mySearchByMoney(loanMoney) {
				this.loanMoney = loanMoney[0];
				this.page = 1;
				this.getList();
			},
			mySearchByContact(call_tag) {
				this.call_tag = call_tag;
				this.page = 1;
				this.getList();
			},
			mySearchByStatus(status) {
				this.status = status;
				this.page = 1;
				this.getList();
			},
			mySearchByStart(start) {
				this.start = start;
				this.page = 1;
				this.getList();
			},
			mySearchByCar(is_car) {
				this.is_car = is_car;
				this.page = 1;
				this.getList();
			},
			mySearchByHouse(is_house) {
				this.is_house = is_house;
				this.page = 1;
				this.getList();
			},
			mySearchByAccumulation(is_accumulation) {
				this.is_accumulation = is_accumulation;
				this.page = 1;
				this.getList();
			},
			mySearchBySocial(is_social_security) {
				this.is_social_security = is_social_security;
				this.page = 1;
				this.getList();
			},
			mySearchByWeilidai(is_weilidai) {
				this.is_weilidai = is_weilidai;
				this.page = 1;
				this.getList();
			},
			mySearchBySalary(is_salary) {
				this.is_salary = is_salary;
				this.page = 1;
				this.getList();
			},
			mySearchBySort(orderBy) {
				this.orderBy = orderBy;
				this.page = 1;
				this.getList();
			},
			mySearchByCreditCard(is_credit_card) {
				this.is_credit_card = is_credit_card;
				this.page = 1;
				this.getList();
			},
			mySearchByPayTaxes(is_pay_taxes) {
				this.is_pay_taxes = is_pay_taxes;
				this.page = 1;
				this.getList();
			},
			mySearch() {
				this.page = 1;
				this.getList();
			},
			addRecordClick(e) {
				let id = e.currentTarget.dataset.id;
				this.oldDatas = this.datas;
				this.addRecordId = id;
				this.modal = true;
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			applyTimeChange(e) {
				this.apply_time = e;
				this.getList();
			},
			joinTimeChange(e) {
				this.join_time = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.categoryList = res.data.list;
				}
				var data = {
					token: that.token,
					getSelf: 1,
				};
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
					that.columns[1].filters = res.data.list;
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getCount() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getCount(that, data);
				if (res.code == 1) {
					that.$Message.success('获取成功');
					that.countData = res.data;
				}
			},
			initSearch() {
				this.name = '';
				this.timeDimension = [];
				this.timePeriod = 0;
				this.notFollowTime = false;
				this.isComment = 0;
				this.page = 1;
				this.apply = [];
				this.media = [];
				this.start = [];
				this.status = [];
				this.call_tag = [];
				this.is_offer = [];
				this.clientType = [];
				this.timePeriodDate = [];
				this.apply_time = [];
				this.join_time = [];
				this.notFollowTimeValue = "";
				this.notFollowJoinTimeValue = "";
				this.is_house = '';
				this.is_car = '';
				this.is_accumulation = '';
				this.is_social_security = '';
				this.is_weilidai = '';
				this.is_salary = '';
				this.is_credit_card = '';
				this.is_pay_taxes = '';
				this.followUid = '';
				this.followDepartment = '';
				this.orderBy = '';
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {

				let that = this;
				var data = this.$data;
				data.limit = this.pageSize;
				data.menu = this.menu;
				data.token = this.token;
				data.page = this.page;
				let res = await getList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
				that.getUserInfo();
			},
			addClue() {
				let that = this;
				this.addClientModal = true;
			},
			addClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addClientModal = false;
						that.getList();
					}
				}, 500)
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				let name = e.name || e.currentTarget.dataset.name;
				this.clientId = id;
				this.editDiv = true;
				this.$nextTick(function() {
					/*
					that.oldDatas = that.datas;
					that.editModal = true;
					*/
				   
					this.$router.push({
					    name: 'newEditClue',
					    params: {
							id: id,
							name:name,
							data:that.datas
					    }
					})
										
				})
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.userList) {
						this.giveOutUid.push(this.userList[i].id);
					}
				} else {
					this.giveOutUid = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 3) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长
				if (this.userInfo.media_is_open !== true) { //此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter(col => col.key !== 'media_name')
				} else {
					this.columns = this.columnsCopy
				}
			},
			clickGiveOut(e) {
				let that = this;
				this.giveOutId = e.currentTarget.dataset.id;
				that.giveOutModal = true;
			},
			giveOut() {
				let that = this;
				let ids = that.giveOutId;
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
			giveOutBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
			transferBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await transferUser(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.transferModal = false;
						that.getList();
					}
				}, 2000);
			},
			allUnlock() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量解锁吗？',
					onOk: async () => {
						let res = await allUnlock(that, {
							token: that.token,
							ids: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addPoolBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addSea(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公海吗？',
					onOk: async () => {
						let res = await addSea(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addPool(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			async getTipsList(e) {
				let that = this;
				var data = {};
				data.menu = e.currentTarget.dataset.type;
				data.token = this.token;
				data.limit = 10;
				let res = await getList(that, data);
				that.datas = res.data.list;
			},
			async lock(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let res = await lock(that, {
					token: that.token,
					id: id
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getList();
				}
			},
			quickEditClient() {
				this.clientId = this.addRecordId;
				this.addRecordId = 0;
				this.modal = false;
				this.editDiv = true;
				this.$nextTick(function() {
					this.editModal = true;
				})
			},
			beforeEditOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			nextEditOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			beforeOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			},
			nextOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			}
		}
	}
</script>
<style scoped lang="less">
	/*栅格表开始*/
	.selectdiv .panel-body {
		padding: 20px 10;
		width: 100%;
		display: inline-block;
	}

	.selectdiv .btn {
		border-radius: 2px;
		margin: 5px 5px;
	}

	.team_btn1_rf {
		margin-top: 5px;
	}

	.rili_out {
		height: 36px;
		float: right;
		position: relative;
	}

	.rili_out .main_data {
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 99;
		background: #ffffff;
		padding: 10px;
		border-radius: 4px;
		border: 1px #dddddd solid;
	}

	.rili_out .prompt {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 8px;
		height: 8px;
		background: red;
		border-radius: 50%;
		border: 1px #ffffff solid;
	}

	.rili_out .btn_closerl {
		position: absolute;
		right: -10px;
		top: -10px;
		cursor: pointer;
	}

	#lk_content .callrecord {
		min-width: 1400px;
	}

	.callrecord-top {
		color: #FFFFFF;
		background-color: #db5a63;
	}

	#lk_content {
		width: 100%;
	}

	.callrecord .acco {
		cursor: pointer;
		color: red;
	}

	.callrecord .next2 {
		cursor: pointer;
		color: #8B0000;
	}

	#lk_content .callrecord-top .tit7 {
		width: 300px;
	}

	#lk_content .callrecord-top .tit15 {
		width: 120px;
	}

	#lk_content .callrecord-top .tit16 {
		width: 120px;
	}
</style>
<style scoped lang="less">
	.input-group .chaxun {
		padding: 6px;
	}

	.input-group .my_client {
		height: 30px;
		background: none;
		border-left: 1px #CCCCCC solid;
		padding: 6px 0;
	}

	.p {
		color: #409eff;
	}

	.form-list .info-inline .name {
		float: left;
		line-height: 38px;
		background: #f0f0f0;
		border-right: 1px solid #ddd;
		padding: 0 18px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.form-list {
		width: 100%;
		display: inline-block;
		clear: both;
		padding: 8px 0;
	}

	.form-list .info-inline {
		width: 16%;
		height: 40px;
		float: left;
		margin: 7px .5%;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .info-inline .right {
		overflow: auto;
		position: relative;
	}

	.form-list .mar-let {
		margin-left: 2%;
	}

	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #F2F2F2;
		color: #E8410B;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			margin-top: 5px;
		}
	}

	.inline {
		display: inline-block;
		width: 30%;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
